import React, { useState } from 'react';
import './ColumnSettingsModal.css';
import axios from 'axios';
const host = process.env.REACT_APP_API_HOST; // API 地址


function ColumnSettingsModal({ allColumns, visibleColumns, onSubmit, onCancel }) {
    const [selectedColumns, setSelectedColumns] = useState(visibleColumns);

    const handleCheckboxChange = (columnName, isChecked) => {
        setSelectedColumns((prev) =>
            isChecked ? [...prev, columnName] : prev.filter((name) => name !== columnName)
        );
    };

    const saveUserSettings = (userId, settings) => {
        const token = localStorage.getItem('token');
        const user_id = localStorage.getItem('user_id');

        axios
            .post(
                `${host}/api/data/user_settings`,
                { user_id: user_id, settings },
                { headers: { Authorization: `Bearer ${token}` } }
            )
            .then(() => {
                console.log('Settings saved successfully');
            })
            .catch((error) => {
                console.error('Failed to save settings:', error);
            });
    };

    const handleSubmit = () => {
        const userId = localStorage.getItem('userId');

        // 更新 localStorage
        const userSettings = JSON.parse(localStorage.getItem('userSettings')) || {};
        const tableSettings = userSettings.tableSettings || {};
        tableSettings.filters = (tableSettings.filters || []).filter((filter) =>
            selectedColumns.includes(filter.id)
        );  
        tableSettings.visibleColumns = selectedColumns;
        userSettings.tableSettings = tableSettings;
    
        localStorage.setItem('userSettings', JSON.stringify(userSettings));

        // 保存到后端
        saveUserSettings(userId, userSettings);

        onSubmit(selectedColumns);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>列显示设置</h2>
                <div className="column-settings">
                    {allColumns.map((col) => (
                        <div className="column-setting-item" key={ col.Header||col.accessor}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={selectedColumns.includes(col.Header||col.accessor)}
                                    onChange={(e) =>
                                        handleCheckboxChange(col.Header||col.accessor, e.target.checked)
                                    }
                                />
                                {col.Header}
                            </label>
                        </div>
                    ))}
                </div>
                <div className="modal-actions">
                    <button onClick={handleSubmit}>提交</button>
                    <button onClick={onCancel}>取消</button>
                </div>
            </div>
        </div>
    );
}

export default ColumnSettingsModal;